import { useEffect, useState } from 'react';
import { eventBus } from '@atc/cai-event-bus';
import { UDS_CONFIG_COMPLETED } from '../constants/events';

export default function useWalletCalcConfig(payments, listing, buildConfig = true) {
    const [config, setConfig] = useState({});

    const updateConfiguration = (data) => {
        setConfig(data);
    };

    useEffect(() => {
        eventBus.on(UDS_CONFIG_COMPLETED, updateConfiguration);

        return () => {
            eventBus.off(UDS_CONFIG_COMPLETED, updateConfiguration);
        };
    }, [payments, listing, buildConfig]);

    return config;
}
